import { IClassname } from '@/lib/shared/model/classname';

export const BedroomSVG = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.44409 15.4438H26.5546C26.8493 15.4438 27.1319 15.5609 27.3403 15.7693C27.5486 15.9776 27.6657 16.2603 27.6657 16.5549V20.9993H4.33301V16.5549C4.33301 16.2603 4.45007 15.9776 4.65844 15.7693C4.8668 15.5609 5.14941 15.4438 5.44409 15.4438Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.7775 20.9995V22.6661C28.7775 22.9608 28.6605 23.2434 28.4521 23.4518C28.2437 23.6602 27.9611 23.7772 27.6664 23.7772H4.33374C4.03906 23.7772 3.75645 23.6602 3.54808 23.4518C3.33972 23.2434 3.22266 22.9608 3.22266 22.6661V20.9995H28.7775Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33301 23.7783V26.0005"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.666 23.7783V26.0005"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.44434 15.4446V9.88915C5.44434 9.2998 5.67846 8.73458 6.09519 8.31785C6.51193 7.90111 7.07714 7.66699 7.6665 7.66699H24.3327C24.9221 7.66699 25.4873 7.90111 25.904 8.31785C26.3208 8.73458 26.5549 9.2998 26.5549 9.88915V15.4446"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0001 14.3334C16.0001 14.628 15.883 14.9107 15.6747 15.119C15.4663 15.3274 15.1837 15.4444 14.889 15.4444H8.77807C8.4834 15.4444 8.20079 15.3274 7.99242 15.119C7.78405 14.9107 7.66699 14.628 7.66699 14.3334V13.4112C7.66699 11.889 10.9669 11.5557 11.8335 11.5557C12.3446 11.5557 16.0001 11.9001 16.0001 13.4112V14.3334Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3331 14.3334C24.3331 14.628 24.216 14.9107 24.0077 15.119C23.7993 15.3274 23.5167 15.4444 23.222 15.4444H17.1111C16.8164 15.4444 16.5338 15.3274 16.3254 15.119C16.1171 14.9107 16 14.628 16 14.3334V13.4112C16 11.889 19.3332 11.5557 20.1666 11.5557C20.6777 11.5557 24.3331 11.9001 24.3331 13.4112V14.3334Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.44434 9.88878V6"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5557 9.88878V6"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
